<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span>Lost Card Payment</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Transaction Type">
              <a-input v-model.trim="transactionType.name" disabled />
            </base-input>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <base-input label="Card Number">
              <a-input v-model="cardNumber" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Selling Type" required>
              <a-select
                v-model="formData.card_selling_type_id"
                @change="onChangeCardSellingType"
              >
                <a-select-option
                  v-for="cardSellingType in options.cardSellingTypesFiltered"
                  :key="'CST' + cardSellingType.id"
                  :value="cardSellingType.id"
                >
                  {{ cardSellingType.name }}
                </a-select-option>
              </a-select>
              <div
                v-if="$v.formData.card_selling_type_id.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.card_selling_type_id.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <base-input label="Employee" required>
              <a-input v-model="formData.recruiter" />

              <div v-if="$v.formData.recruiter.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.recruiter.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Price">
              <a-input v-model="formData.price" disabled />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Payment Options" required>
              <a-select
                v-model="formData.payment_type_id"
                @change="onChangePaymentType"
              >
                <a-select-option
                  v-for="paymentType in options.paymentTypesFiltered"
                  :key="'PT' + paymentType.id"
                  :value="paymentType.id"
                >
                  {{ paymentType.name }}
                </a-select-option>
              </a-select>
              <div
                v-if="$v.formData.payment_type_id.$dirty"
                class="text-danger"
              >
                <div class="error" v-if="!$v.formData.payment_type_id.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row" v-if="pointsPaymentType">
          <div class="col">
            <base-input label="Available Points">
              <a-input v-model="availablePoints" disabled />
              <div v-if="$v.availablePoints.$dirty" class="text-danger">
                <div class="error" v-if="!$v.availablePoints.availability">
                  Not enough points. Choose a different payment type
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row" v-if="paymentTypeHasRemarks">
          <div class="col">
            <base-input label="Remarks" :required="paymentTypeHasRemarks">
              <a-input
                v-model.trim="formData.remarks"
                :placeholder="placeholder"
              />
              <div v-if="$v.formData.remarks.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.remarks.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row" v-if="otherTender">
          <div class="col">
            <base-input label="Amount Tendered" required>
              <a-input
                v-model="formData.amount_tendered"
                :disabled="pointsPaymentType"
              />
              <div
                v-if="$v.formData.amount_tendered.$dirty"
                class="text-danger"
              >
                <div class="error" v-if="!$v.formData.amount_tendered.required">
                  Field is required
                </div>
                <div
                  class="error"
                  v-else-if="!$v.formData.amount_tendered.decimal"
                >
                  Value must be a valid number
                </div>
                <div
                  class="error"
                  v-else-if="!$v.formData.amount_tendered.validAmount"
                >
                  Amount tendered must not be lower that the selling price
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Change">
              <a-input v-model="amountTenderedChange" disabled />
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    size="sm"
                    variant="primary"
                    @click.prevent="confirmPayment"
                  >
                    Pay Transaction
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
    <a-drawer
      :width="cardPaymentDetailDrawer.width"
      :placement="cardPaymentDetailDrawer.placement"
      :visible="cardPaymentDetailDrawer.visible"
      @close="closeCardPaymentDetailDrawer"
    >
      <CardPaymentDetailForm
        :cardTransactionData="cardTransactionData"
        @closeDrawer="closeCardPaymentDetailDrawer"
        :viewMode="cardPaymentDetailViewMode"
      />
    </a-drawer>
  </div>
</template>
<script>
import secureStorage from '@/controllers/secureStorage';
import HTTPRequest from '../../../controllers/httpRequest';
import { decimal, required, requiredIf } from 'vuelidate/lib/validators';
import moment from 'moment';
import CardPaymentDetailForm from './CardPaymentDetailForm.vue';

export default {
  name: 'LostCardForm',
  props: {
    transactionType: {
      type: Object,
      default: () => {
        return {
          id: 'LOST_CARD',
          name: 'Lost Card'
        };
      },
      description: 'Default transaction type'
    },
    cardData: {
      type: Object,
      required: true
    }
  },
  components: {
    CardPaymentDetailForm
  },
  validations: {
    formData: {
      card_selling_type_id: {
        required
      },
      payment_type_id: { required },
      recruiter: { required },
      amount_tendered: {
        required,
        decimal,
        validAmount(amountTendered) {
          return amountTendered >= parseFloat(this.formData.price);
        }
      },
      remarks: {
        required: requiredIf(function () {
          return this.paymentTypeHasRemarks;
        })
      }
    },
    availablePoints: {
      availability(availablePoints) {
        return availablePoints >= this.formData.price;
      }
    }
  },

  data() {
    return {
      formSubmitting: false,
      cardTransaction: null,
      otherTender: false,
      selectedCardSellingType: null,
      paymentTypeHasRemarks: false,
      placeholder: '',
      pointsPaymentType: false,
      cardStatusCode: null,
      card_selling_type_id: null,
      cardPaymentDetailViewMode: true,
      formData: {
        trans_id: null,
        site_id: secureStorage.getItem('currentSiteId'),
        card_id: this.cardData.id,
        card_number: this.cardData?.card_number,
        member_id: this.cardData.member_id,
        membership_program_id: this.cardData.membership_program_id,
        membership_level_id: this.cardData.membership_level_id,
        card_selling_type_id: null,
        price: null,
        amount_tendered: null,
        payment_type_id: null,
        transaction_type: this.transactionType.id,
        transaction_date: this.currentDate(),
        recruiter: null,
        remarks: null,
        transaction_status: 'PENDING'
      },
      cardPaymentDetailDrawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      options: {
        paymentTypes: [],
        paymentTypesFiltered: [],
        cardSellingTypesFiltered: [],
        cardSellingTypes: []
      }
    };
  },

  methods: {
    async getPaymentTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/payment_types?status=A'
      );

      this.options.paymentTypes = response.data;
    },
    async getCardSellingTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/card_selling_types?status=A'
      );

      this.options.cardSellingTypes = response.data;
      this.options.cardSellingTypesFiltered = [];
      for (let i = 0; this.options.cardSellingTypes.length > i; i++) {
        if (this.availableCardSellingType(this.options.cardSellingTypes[i])) {
          this.options.cardSellingTypesFiltered.push(
            this.options.cardSellingTypes[i]
          );
        }
      }
    },

    currentDate() {
      return moment().format('MM/DD/YYYY');
    },

    onChangeCardSellingType(cardSellingTypeId) {
      const _selectedCardSellingType = this.options.cardSellingTypes.find(
        (cst) => cst.id == cardSellingTypeId
      );
      this.selectedCardSellingType = _selectedCardSellingType;
      this.formData.price = _selectedCardSellingType.price;
      this.formData.payment_type_id = null;
      this.formData.remarks = null;
      this.paymentTypeHasRemarks = false;
      this.otherTender = true;
      this.options.paymentTypesFiltered = [];
      for (let i = 0; this.options.paymentTypes.length > i; i++) {
        if (this.availablePaymentType(this.options.paymentTypes[i])) {
          this.options.paymentTypesFiltered.push(this.options.paymentTypes[i]);
        }
      }
    },

    onChangePaymentType(paymentTypeId) {
      const _selectedPaymentType = this.options.paymentTypes.find(
        (pt) => pt.id == paymentTypeId
      );

      if (_selectedPaymentType) {
        const _extras = JSON.parse(_selectedPaymentType.extras);

        this.paymentTypeHasRemarks = null;
        if (
          typeof _extras?.hasRemarks !== 'undefined' &&
          _extras?.hasRemarks !== null
        ) {
          this.paymentTypeHasRemarks = _extras.hasRemarks;
        }

        this.placeholder = '';
        if (
          typeof _extras?.remarks_hint_text !== 'undefined' &&
          _extras?.remarks_hint_text !== null
        ) {
          this.placeholder = _extras.remarks_hint_text;
        }
        this.pointsPaymentType = false;
        if (_selectedPaymentType.code === 'POINTS') {
          this.pointsPaymentType = true;
          this.otherTender = false;
          if (this.availablePoints >= this.formData.price) {
            this.formData.amount_tendered = this.formData.price;
          } else {
            this.formData.amount_tendered = 0;
          }

          this.$v.availablePoints.$touch();
        }
        if (_selectedPaymentType.code !== 'CASH') {
          this.otherTender = false;
          this.formData.amount_tendered = this.formData.price;
        } else {
          this.otherTender = true;
          this.formData.amount_tendered = 0;
        }
      }
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },

    clearForm() {
      this.selectedCardSellingType = null;
      this.formData.card_selling_type_id = null;
      this.formData.price = null;
      this.formData.payment_type_id = null;
      this.formData.recruiter = null;
      this.formData.amount_tendered = null;
      this.cardTransaction = null;
      this.pointsPaymentType = false;
    },

    closeCardPaymentDetailDrawer() {
      this.$emit('closeDrawer', null);
      this.cardPaymentDetailDrawer.visible = false;
      this.cardPaymentDetailViewMode = true;
      this.closeDrawer();
    },

    confirmPayment() {
      const _self = this;

      this.$v.formData.$touch();

      if (this.pointsPaymentType) {
        this.$v.availablePoints.$touch();

        if (this.$v.availablePoints.$invalid) {
          return 0;
        }
      }

      if (!this.$v.formData.$invalid) {
        this.$confirm({
          title:
            "Do you want to proceed with the payment? Click 'Yes' to confirm transaction and print the receipt.",
          okText: 'Yes',
          onOk() {
            _self.lostCard();
          },
          onCancel() {}
        });
      }
    },

    async lostCard() {
      this.formSubmitting = true;
      const response = await HTTPRequest.putRequest(
        '/api/v1/cards/lost_card?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        {
          card: this.cardData,
          card_transaction: this.formData
        }
      );

      if (response.id) {
        this.cardPaymentDetailViewMode = false;
        this.$notification.success({
          message: 'Success',
          description: 'Card has been updated.'
        });

        await this.getCardTransaction(response.id);

        this.cardPaymentDetailDrawer.visible = true;
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error,
            placement: 'topLeft'
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }
      }
      this.formSubmitting = false;
    },

    async getCardTransaction(cardId) {
      this.cardTransaction = await HTTPRequest.getRequest(
        '/api/v1/card_transactions/card/' + cardId
      );
    },

    /**
     * Evaluates cardSellingType based on the current transactionType
     * @params {Object} cardSellingType
     * @returns boolean
     */
    availableCardSellingType(cardSellingType) {
      const _transactionType = JSON.parse(cardSellingType.transaction_types);
      return !!_transactionType.includes(this.transactionType.id);
    },

    /**
     * Evaluates paymentType based on the selected cardSellingType
     * @params {Object} cardSellingType
     * @returns boolean
     */
    availablePaymentType(paymentType) {
      const _selectectedCardSellingType = this.selectedCardSellingType || null;
      if (_selectectedCardSellingType != null) {
        const _availablePaymentTypes = JSON.parse(
          _selectectedCardSellingType.payment_types
        );
        return !!_availablePaymentTypes.includes(paymentType.id);
      }

      return false;
    }
  },

  computed: {
    cardNumber() {
      return this.cardData?.card_number ?? null;
    },
    amountTenderedChange() {
      if (
        this.formData.amount_tendered &&
        !isNaN(this.formData.amount_tendered) &&
        this.formData.price !== null
      ) {
        return (this.formData.amount_tendered - this.formData.price).toFixed(2);
      }
      return null;
    },
    cardTransactionData() {
      return this.cardTransaction ?? null;
    },
    availablePoints() {
      return 0;
    }
  },

  created() {
    this.getPaymentTypes();
    this.getCardSellingTypes();
  }
};
</script>

<style scoped></style>
